export default __webpack_public_path__ + "static/logo-7-dc1c3ca39f7d912e15a5bff2057cb21d.png";